<script>
export default {
  name: "AnonymousWrapper"
}
</script>

<template>
<router-view></router-view>
</template>

<style scoped>

</style>